import type { IconData } from '@stacksjs/iconify-core'

export const mc1x1: IconData = {
  "body": "<g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"#f31830\" d=\"M0 0h512v256H0z\"/><path fill=\"#fff\" d=\"M0 256h512v256H0z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default mc1x1
